import { authConfig } from '../config';
import type { SyncLoginParams } from '../types';

/**
 * Builds the absolute URL to redirect the user to the Sync Hosted SSO `/login`
 * page. All values are URL-encoded by `URLSearchParams`.
 *
 * Important: uses `authConfig.startUpUrl` (the Hosted SSO **frontend** host),
 * which is different from `authConfig.baseUrl` (the **API** host). Swapping one
 * for the other yields 500/403 responses from the Sync ELB.
 */
export function buildLoginUrl(params: SyncLoginParams): string {
  const base = authConfig.startUpUrl.replace(/\/+$/, '');

  const search = new URLSearchParams({
    redirectUri: params.redirectUri,
    clientId: params.clientId,
    authorization: params.authorization,
    state: params.state,
  });

  if (params.email) search.append('email', params.email);
  if (params.taxIdentifier)
    search.append('taxIdentifier', params.taxIdentifier);

  return `${base}/login?${search.toString()}`;
}
